import { createContext, useContext, useState, PropsWithChildren } from 'react';

/**
 * On some diagrams the hotspot dots cover up the part number printed on the
 * image itself. This lets a viewer hide every dot (and its white background
 * circle) so they can read what's underneath, then bring them back.
 */
const DotsVisibilityContext = createContext({
   dotsVisible: true,
   hideDots: () => {},
   setDotsVisible: (_visible: boolean) => {},
});

function DotsVisibilityProvider({ children }: PropsWithChildren) {
   const [dotsVisible, setDotsVisible] = useState(true);

   const value = {
      dotsVisible,
      hideDots: () => setDotsVisible(false),
      setDotsVisible,
   };

   return <DotsVisibilityContext.Provider value={value}>{children}</DotsVisibilityContext.Provider>;
}

function useDotsVisibility() {
   return useContext(DotsVisibilityContext);
}

export { DotsVisibilityProvider, useDotsVisibility };
